import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const SystemIntegration = () => {
  return (
    <>
      <SEO 
        title="System Integration Services - Abacies Logiciels"
        description="Seamlessly integrate your existing systems with modern platforms and applications. Abacies provides enterprise system integration services including API development, data synchronization, and legacy system modernization."
        keywords="system integration, enterprise integration, API integration, legacy system integration, data integration, system modernization"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              System Integration
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the System Integration page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for System Integration. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default SystemIntegration;
